import { createWeb3Modal } from '@web3modal/wagmi/react';
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config';
import { WagmiProvider } from 'wagmi';
import {
  mainnet,
  polygon,
  arbitrum,
  optimism,
  bsc,
  avalanche,
  sepolia,
  polygonAmoy,
  arbitrumSepolia,
  optimismSepolia,
  bscTestnet,
  avalancheFuji,
  base,
  baseSepolia,
  gnosis,
  fantom,
  celo,
  zkSync,
  linea,
  scroll
} from 'wagmi/chains';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// 0. Setup queryClient
const queryClient = new QueryClient();

// 1. Get projectId from WalletConnect Cloud
const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || 'demo-project-id';

// 2. Create wagmiConfig
const metadata = {
  name: 'ZPayNow',
  description: 'Zero-Custody Payment Gateway',
  url: 'https://zpaynow.com',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
};

// Support all major networks including testnets
const chains = [
  mainnet,
  polygon,
  arbitrum,
  optimism,
  bsc,
  avalanche,
  base,
  gnosis,
  fantom,
  celo,
  zkSync,
  linea,
  scroll,
  // Testnets
  sepolia,
  polygonAmoy,
  arbitrumSepolia,
  optimismSepolia,
  bscTestnet,
  avalancheFuji,
  baseSepolia
];

const wagmiConfig = defaultWagmiConfig({
  chains,
  projectId,
  metadata
});

// 3. Create modal
createWeb3Modal({
  wagmiConfig,
  projectId,
  enableAnalytics: true,
  themeMode: 'dark',
  themeVariables: {
    '--w3m-accent': '#6366f1',
    '--w3m-border-radius-master': '8px'
  }
});

export function Web3Provider({ children }) {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export { wagmiConfig };
